import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import SmartEmailTemplateEditor from './SmartEmailTemplateEditor';

export default async function action() {
  return {
    title: 'Smart Email Template Editor',
    component: (
      <AdminLayout>
        <SmartEmailTemplateEditor />
      </AdminLayout>
    )
  };
}
